import {Component} from "./Component";
import {hasParent} from "../util/dom";
import {createLogger} from "../util/logger";

const console = createLogger("Monthpicker");

export class Monthpicker extends Component {
    static name = "monthpicker";

    get name() {
        return Monthpicker.name;
    }

    constructor(el) {
        super(el);

        this.$input = this.querySelector("input");


        const [year, month] = this.$input.value.split("-");
        console.log({year, month});

        this.currentYear = (new Date()).getFullYear();

        this.currentMonth = (new Date()).getMonth();

        this.selectedYear = parseInt(year) || this.currentYear;

        this.selectedMonth = month ? parseInt(month) -1 : this.currentMonth;

        console.log(this.selectedMonth, this.selectedYear)

        /**
         * @type {HTMLElement}
         */
        this.$overlay = this.$("overlay");

        /**
         * @type {HTMLElement}
         */
        this.$btnPrev = this.$("btnPrevYear");

        /**
         * @type {HTMLElement}
         */
        this.$btnNext = this.$("btnNextYear");

        /**
         * @type {HTMLElement}
         */
        this.$btnConfirm = this.$("btnConfirm");

        /**
         * @type {HTMLElement}
         */
        this.$btnReset = this.$("btnReset");

        /**
         * @type {HTMLElement}
         */
        this.$currentYear = this.$("currentYear");

        /**
         * @type {HTMLElement[]}
         */
        this.$months = this.$("months");

        this.addEventListener(this.querySelectorAll("button"), "click", (e) => e.preventDefault());

        this.addEventListener(this.$btnPrev, "click", this.onClickPrevYear.bind(this));
        this.addEventListener(this.$btnNext, "click", this.onClickNextYear.bind(this));
        this.addEventListener(this.$btnConfirm, "click", this.onClickConfirm.bind(this));
        this.addEventListener(this.$btnReset, "click", this.onClickReset.bind(this));

        this.addEventListener(this.$input, "focus", this.onFocus.bind(this));

        this.addEventListener(this.$months, "click", this.onClickMonth.bind(this));

        this.addEventListener(document.body, "click", this.onClickOutside.bind(this));

        this.setCurrentYear(this.selectedYear);
        this.setCurrentMonth(this.selectedMonth);

    }

    /**
     * @param {MouseEvent} e
     */
    onClickPrevYear(e) {
        if (this.currentYear > this.selectedYear - 1) return;

        this.setCurrentYear(this.selectedYear - 1);
    }

    /**
     * @param {MouseEvent} e
     */
    onClickNextYear(e) {
        this.setCurrentYear(this.selectedYear + 1);
    }

    /**
     * @param {MouseEvent} e
     */
    onClickMonth(e) {
        this.setCurrentMonth(this.$months.indexOf(e.currentTarget));
    }

    /**
     * @param {MouseEvent} e
     */
    onClickConfirm(e) {
        this.$input.value = `${this.getFormattedMonthName()}`;
        this.$input.setAttribute("data-value", `${this.selectedYear}-${String(this.selectedMonth + 1).padStart(2, "0")}`);

        this.hide();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickReset(e) {
        this.setCurrentMonth(this.currentMonth);
        this.$input.value = ``;
        this.$input.setAttribute("data-value", "");
        this.hide();
    }

    /**
     * @type {FocusEvent} e
     */
    onFocus(e) {
        this.show();
    }

    /**
     * @type {FocusEvent} e
     */
    onBlur(e) {
        this.hide();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickOutside(e) {
        if (!this.open) return;

        if (hasParent(e.target, this.el)) {
            return;
        }

        this.hide();
    }

    /**
     * Updates current year and UI
     * @param year
     */
    setCurrentYear(year) {
        this.selectedYear = year;

        this.$currentYear.innerText = year;

        if (this.selectedYear === this.currentYear && this.selectedMonth < this.currentMonth) {
            this.setCurrentMonth(this.currentMonth);
        }

        this.$months.forEach((el, i) => {
            if (this.selectedYear !== this.currentYear) {
                el.removeAttribute("disabled");
            } else if (i < this.currentMonth) {
                el.setAttribute("disabled", "");
            }
        });

    }


    setCurrentMonth(month) {
        this.selectedMonth = month;

        this.$months.forEach((el, i) => {
            if (i !== month) {
                el.classList.remove("--selected");
            } else {
                el.classList.add("--selected");
                this.selectedMonth = Math.min(11, Math.max(0, i));
            }
        });
    }

    getFormattedMonthName() {
        const $month = this.$months[this.selectedMonth];

        return `${$month.getAttribute("data-name")} ${this.selectedYear}`;
    }


    /**
     * Shows overlay
     */
    show() {
        if (this.open) return;

        this.open = true;
        this.el.classList.add("--visible");

        this.$overlay.focus();
    }

    /**
     * Hides overlay
     */
    hide() {
        if (!this.open) return;

        this.open = false;
        this.el.classList.remove("--visible");
    }

    destroy() {
        super.destroy();

        this.el.classList.remove("--visible");
    }


}
